module.exports = __webpack_public_path__ + "assets/discount_black-466ebb.svg";